// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-YiF","comment":"styles_comment__3bTYu"};